export const validateZip = (values) => {
    const errors = {};

    // if (!values.schedules || values.schedules.length === 0) errors.schedules = 'Required';
    if (!values.county) errors.county = 'Required';

    if (!values.zip) errors.zip = 'Required';
    else if (!/^[0-9]{5}$/.test(values.zip)) errors.zip = 'Invalid Zip Code';

    if ((values.county ?? '').length > 50) errors.note = 'Too long. 50 is the max length.';
    if ((values.note ?? '').length > 4000) errors.note = 'Too long. 4000 is the max length.';

    return errors;
}